// extracted by mini-css-extract-plugin
export default {"compactProgress":"TimeProgressBar_compactProgress__A3gkw","compactProgressValue":"TimeProgressBar_compactProgressValue__FQjua"};